
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { AppType } from "./app-type";
import { AdvanceSearchTime } from "./advance-search-time";
import { AdvanceSearchThroughType } from "./advance-search-through";
import { Project } from "./project";
import { MyUser } from "./user";
import { AdvanceSearchTag } from "./advance-search-tag";
import { AdvanceSearchDueDateTime } from "./advance-search-duedate-time";
import { AdvanceSearchUser } from "./advance-search-user";
import { AdvanceSearchList } from "./advance-search-list";
import { AdvanceSearchLocation } from "./advance-search-location";

export interface AdvanceSearchRequest {
  app_types: AppType[];

  time: AdvanceSearchTime;
  dueDateTime: AdvanceSearchDueDateTime;

  search_through_type: AdvanceSearchThroughType;

  assignees: AdvanceSearchUser;
  projects: Project[];
  tags: AdvanceSearchTag;
  lists: AdvanceSearchList;
  locations: AdvanceSearchLocation;
  attachments: boolean;
  closed_tasks: boolean;
  save_searches: boolean;
}
